import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// DELETE A FORM
const submit = (payload) => client.put('forms/types', payload);
export const useDeleteForm = (payload) => useMutation(['deleteForm'],() => submit(payload))


//DEACTIVATE A FORM
const submitForm = (id) => client.delete(`forms/${id}`);
export const useDeactivateForm = (id) => useMutation(['deleteFormType',id],() => submitForm(id))

//DEACTIVATE A COMMENT
const deleteComment = (id) => client.delete(`forms/${id}`);
export const useDeleteComment = (id) => useMutation(['deleteCommentType',id],() => deleteComment(id))



//Reject A FORM
const rejectForm = ({formId,officerId}) => client.delete(`forms/reject/${formId}/${officerId}`);
export const useRejectForm = (formId) => useMutation(['rejectForm',formId],({formId,officerId}) => rejectForm({formId,officerId}))